import React from 'react';

const InfoBox = ({ selectedCountry }) => {
    if (!selectedCountry) return <div></div>;

    return (
        <div>
            <h2>{selectedCountry.country}</h2>
            <p>Status: {selectedCountry.status}</p>
            <p>Visited on: {selectedCountry.visitDate}</p>
            <p>Details: {selectedCountry.details}</p>
        </div>
    );
};

export default InfoBox;
